import { IDisposable } from "Core/Interfaces";

export abstract class BaseLayout implements IDisposable {
    private view: kendo.View;

    constructor(private layout: kendo.Layout, private viewModel: Object) {}

    abstract apply(): void;

    private setLayout(container: string, layout: string) {
        this.view = new kendo.View(layout, {
            model: this.viewModel,
            wrap: false,
            evalTemplate: true,
        });
        this.layout.containers = {};
        this.layout.showIn(container, this.view);
    }

    resize(): void {}

    setMenuLayout(layout: string) {
        this.setLayout(".dms-menu-layoutwrapper", layout);
    }

    setContentLayout(layout: string) {
        this.setLayout(".dms-layout-wrapper", layout);
    }

    dispose(): void {
        if (this.view) {
            this.view.destroy();
        }
    }
}
